var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.v$.fm)?_c('DynamicForm',_vm._g({ref:"form",attrs:{"form":_vm.v$.fm},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)},_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }